import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from 'app/services/utilities/language.service';
import { UntypedFormControl, Validators, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ErrorMatcher } from '../login/error-matcher';
import { AuthenticationService } from 'app/services/data/authentication.service';

@Component({
    selector: 'app-verify-account',
    templateUrl: './verify-account.component.html',
    styleUrls: ['./verify-account.component.scss']
})
export class VerifyAccountComponent implements OnInit {
    validationMethods = {
        'CALL': 'Call',
        'EMAIL': 'Email',
        'SMS': 'SMS',
    };
    form: UntypedFormGroup;
    codeForm: UntypedFormGroup;
    isLoading: WritableSignal<boolean> = signal(false);
    isInfoCard: boolean = true;
    isVerificationSuccess: boolean = false;
    second: number = 3;

    constructor(
        public errorMatcher: ErrorMatcher,
        private activatedRoute: ActivatedRoute,
        private languageService: LanguageService,
        private fb: UntypedFormBuilder,
        private router: Router,
        private authenticationService: AuthenticationService
    ) {
        this.errorMatcher.clear();
    }

    get loginID(): string {
        return this.activatedRoute.snapshot.params.loginID;
    }
    get emailFC() {
        return this.form.get('email');
    }
    get phoneNumberFC() {
        return this.form.get('phoneNumber');
    }

    ngOnInit() {
        this.form = this.fb.group({
            loginID: [{ value: this.activatedRoute.snapshot.params.loginID, disabled: true }],
            validationMethod: [this.validationMethods.SMS, [Validators.required]],
            phoneNumber: [null],
            email: [null, [Validators.email]],
        });
        this.codeForm = this.fb.group({
            code: new UntypedFormControl(null, [Validators.required])
        });
        this.form.get('validationMethod').valueChanges.subscribe(val => {
            if (val === this.validationMethods.EMAIL) {
                this.phoneNumberFC.clearValidators();
                this.emailFC.setValidators([Validators.required, Validators.email]);
            } else {
                this.emailFC.clearValidators();
                this.phoneNumberFC.setValidators([Validators.required]);
            }
            this.form.updateValueAndValidity();
        });
    }

    /**
     * Initiate the account validation
     */
    submit() {
        this.form.markAllAsTouched();
        if (this.form.valid) {
            this.isLoading.set(true);
            const data = {
                loginID: this.loginID,
                validationMethod: this.form.get('validationMethod').value,
                email: this.emailFC.value,
                phoneNumber: this.phoneNumberFC.value,
                language: this.languageService.getLanguage(),
            };
            this.authenticationService.verifyAccount(data)
                .subscribe({
                    next: () => {
                        this.isInfoCard = false;
                        if (this.form.get('validationMethod').value === this.validationMethods.EMAIL) {
                            this.redirect();
                        }
                        this.errorMatcher.clear();
                        this.isLoading.set(false);
                    },
                    error: err => {
                        this.errorMatcher.setError(err);
                        this.isLoading.set(false);
                    }
                });
        }
    }
    /**
     * Validation form after receiving the authentication code
     */
    verifyValue(): void {
        this.codeForm.markAllAsTouched();
        if (this.codeForm.valid) {
            this.isLoading.set(true);
            const data = { code: this.codeForm.get('code').value, loginID: this.loginID };
            this.authenticationService.verifyCodeValue(data)
                .subscribe({
                    next: () => {
                        this.redirect();
                        this.isVerificationSuccess = true;
                        this.isLoading.set(false);
                    },
                    error: err => {
                        this.errorMatcher.setError(err);
                        this.isLoading.set(false);
                    }
                });
        }
    }

    redirect(): void {
        let id = setInterval(() => {
            if (this.second === 0) {
                clearInterval(id);
                this.router.navigate(['login']);
            } else {
                this.second--;
            }
        }, 1000);
    }
}
